module.exports = __webpack_public_path__ + "img/logo alterno color oro.8db34417.png";